import { useEffect, useMemo } from 'react';

import { Modals } from '@/helpers/modals';
import {
  AUTH_FIELD_MISSED_COUNTRY,
  AUTH_FIELD_MISSED_TERMS,
  GOOGLE_OAUTH_NAME,
} from '@/helpers/oauth';
import { useCommonStore, useModalsStore } from '@/store';

export const useConfirmRegistrationOrTerms = () => {
  const open = useModalsStore.use.open();
  const user = useCommonStore.use.user();
  const pendingUserPure = useCommonStore.use.pendingUserPure();
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const authProvidersOptions = useCommonStore.use.authProvidersOptions();

  const isRegisteredWithGoogle = useMemo(
    () => authProvidersOptions.some(({ name }) => name === GOOGLE_OAUTH_NAME),
    [authProvidersOptions]
  );

  const missedFields = user?.authFieldsMissed;

  useEffect(() => {
    if (pendingUserPure || !isAuthenticated || !missedFields) return;

    if (isRegisteredWithGoogle) {
      if (
        missedFields.includes(AUTH_FIELD_MISSED_COUNTRY) &&
        missedFields.includes(AUTH_FIELD_MISSED_TERMS)
      ) {
        return open(Modals.ConfirmGoogleRegistration);
      }

      if (missedFields.includes(AUTH_FIELD_MISSED_COUNTRY)) {
        return open(Modals.ConfirmGoogleCountry);
      }
    }

    if (missedFields.includes(AUTH_FIELD_MISSED_TERMS)) {
      return open(Modals.TermsAndConditionsAcceptance);
    }
  }, [
    user,
    isRegisteredWithGoogle,
    pendingUserPure,
    isAuthenticated,
    missedFields,
    open,
  ]);
};
